import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Typography } from '@material-ui/core';

import useStyles from './useStyles';

export const PromptWithUrlHint = forwardRef(
  ({ className, onNextClick, dontShowAgain, onDontShowAgainChange }, ref) => {
    const styles = useStyles();

    const handleClose = () => {
      onNextClick();
      onDontShowAgainChange();
    };

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
      >
        <div className={styles.titlesContainer}>
          <Typography className={styles.title}>🚀 HUGE news!</Typography>
          <Typography className={styles.subtitle}>
            Now you can add links as a reference for your prompts!
            <br />
            Add a url and Anyword will analyze and understand its content –
            <br />
            making the creation of prompts quick and easy!
          </Typography>
        </div>

        <div className={styles.examplesContainer}>
          <Typography className={styles.examplesTitle}>Examples</Typography>
          <Typography className={styles.examplesParagraph}>
            • Write an elevator pitch for www.anyword.com
            <br />• Write a brief summary of the article found at anyword.com/blog
          </Typography>
        </div>

        <Button
          className={styles.button}
          classes={{ label: styles.buttonLabel }}
          variant="contained"
          color="primary"
          onClick={handleClose}
        >
          Try now
        </Button>

        <div className={styles.arrow} />
      </div>
    );
  }
);

PromptWithUrlHint.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  dontShowAgain: PropTypes.bool,
  onDontShowAgainChange: PropTypes.func.isRequired,
};

PromptWithUrlHint.defaultProps = {
  className: null,
  dontShowAgain: false,
};
